import { useState } from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { handleLogout } from '@/api/client';
import { runStore, useRunStore } from '@/features/chat/runs/runStore';

/** Confirms signing out; says how many answers in progress it stops, and stops them. */
const SignOutDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  // Every own answer in progress, also those another tab or device follows.
  const generating = useRunStore().ownActiveCount();
  const [signingOut, setSigningOut] = useState(false);

  const signOut = async () => {
    setSigningOut(true);
    // Spec §5: signing out stops active requests (the server, not just the tab).
    await runStore.stopAll();
    handleLogout();
  };
  return (
    <Modal
      open={open}
      title={t('v2.shell.signOutTitle')}
      width={460}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('v2.common.cancel')}
        </Button>,
        <Button
          key="sign-out"
          type="primary"
          loading={signingOut}
          onClick={() => void signOut()}
          data-testid="confirm-sign-out"
        >
          {t('v2.shell.signOut')}
        </Button>,
      ]}
    >
      <p>{t('v2.shell.signOutBody')}</p>
      {generating > 0 ? (
        <p style={{ marginTop: 8 }}>
          {t('v2.shell.signOutRunning', { count: generating })}
        </p>
      ) : null}
    </Modal>
  );
};

export default SignOutDialog;
